import type { FormError } from 'core/components';
import { CustomError } from './CustomError';
import { ErrorCodes } from '../literals';

export class ValidationError extends CustomError {
  constructor(public data: FormError[]) {
    super('Validation error', ErrorCodes.validation, data);
  }
}
